exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1UUMy{width:100%;background-color:#858585;color:#999;padding-top:10px;font-size:11px;font-weight:300;font-family:Open Sans,Helvetica,Arial,sans-serif}", ""]);

// exports
exports.locals = {
	"root": "_1UUMy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Footer/Footer.css
// module id = 1048
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13